<label for="file">{{ fieldDefinition.label | translate}}</label>
<input type="file" id="file" (change)="handleFileInput($event.target.files)">